export enum eLanThiTongHop {
    LAN_1 = 1,
    LAN_2 = 2,
    CAO_NHAT = 3,
}